import React, {useEffect, useState} from 'react';
import moment from 'moment/moment';
import FboDetails from '../../../SVG/FBODetails';
import Pencil from '../../../SVG/Pencil';
import Trash from '../../../SVG/Trash';
import {useLocation, useNavigate} from 'react-router-dom';
import SimpleModal from '../../SimpleModal';
import {useDeleteCustomInspectionCategoryMutation} from '../../../store/builder/inspections.api';
import {toast} from 'react-toastify';
import useLoader from '../../../global/UseLoadingHandler';
import {useErrorHandler} from '../../../global/ErrorsHandler';
import {useTranslation} from '../../../hooks/useTranslation';

const FormRow = ({item, setList, getFormsList, userType}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const {t} = useTranslation();
  const [deleteModal, setDeleteModal] = useState(false);

  const [
    removeCategory,
    {
      data: removeCategoryData,
      isError: removeCategoryIsError,
      isLoading: removeCategoryIsLoading,
      error: removeCategoryError,
      isSuccess: removeCategoryIsSuccess,
    },
  ] = useDeleteCustomInspectionCategoryMutation();

  const [errorHandler, setErrorHandler] = useErrorHandler([
    removeCategoryError,
  ]);

  useLoader([removeCategoryIsLoading]);

  useEffect(() => {
    return window.addEventListener('click', e => {
      if (
        e.target.closest('.userSettings') === null &&
        e.target.closest('.management__table-settings') === null
      ) {
        setList(old => {
          let data = [...old];
          data?.map(item => {
            item.actions_status = false;
          });
          return data;
        });
      }
    });
  }, [location]);

  const toggleActions = id => {
    setList(old => {
      let newArr = [...old];
      newArr.map(el => {
        if (el.id === id) {
          el.actions_status = !el.actions_status;
        } else {
          el.actions_status = false;
        }
        return el;
      });
      return newArr;
    });
  };

  const deleteForm = () => {
    removeCategory(item?.id)
      .unwrap()
      .then(res => {
        getFormsList();
        toast.success(t('forms.messages.formDeletedSuccess'));
        setDeleteModal(false);
      })
      .catch(err => {
        setDeleteModal(false);
      });
  };

  const renderDeleteModal = () => {
    return (
      <SimpleModal
        isDelete={true}
        exit={() => setDeleteModal(false)}
        submitAction={deleteForm}
        submitTitle={t('actions.delete')}
        title={t('forms.modals.deleteTitle')}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            padding: '10px 0',
          }}
        >
          <p>{t('forms.modals.deleteMessage')}</p>
        </div>
      </SimpleModal>
    );
  };

  return (
    <div className='forms__table-row' key={item?.id}>
      {deleteModal && renderDeleteModal()}
      {item?.actions_status && (
        <div className='management__table-settings fbo forms'>
          {/*<div className="management__table-edit details" onClick={() => {*/}
          {/*  navigate(`/forms/${item.id}`)*/}
          {/*}}>*/}
          {/*  <FboDetails/>*/}
          {/*  <span>Form Details</span>*/}
          {/*</div>*/}
          <div
            className='management__table-edit details'
            onClick={() => {
              navigate(
                `/${userType === 'corporate' ? 'corporate/' : ''}forms/edit-form/${item?.id}`,
                {state: {userType: userType}},
              );
            }}
          >
            <Pencil color={'#999999'} />
            <span>{t('forms.actions.editForm')}</span>
          </div>
          <div
            className='management__table-edit'
            onClick={() => {
              setDeleteModal(true);
            }}
          >
            <Trash color={'#DA6767'} />
            <span>{t('forms.actions.deleteForm')}</span>
          </div>
        </div>
      )}

      <div className='forms__table-bodyTh'>{item?.name}</div>
      <div className='forms__table-bodyTh'>
        {moment(item?.created_at).format('MM/DD/YY')}
      </div>
      <div className='forms__table-bodyTh'>{item?.fields_count}</div>
      <div className='forms__table-bodyTh'>
        {moment(item?.updated_at).format('MM/DD/YY')}
      </div>
      <div className='forms__table-bodyTh'>{item?.created_by?.name}</div>
      <div className='forms__table-bodyTh userSettings'>
        <img
          src='/assets/icons/dots.svg'
          alt='dots'
          onClick={() => toggleActions(item?.id)}
        />
      </div>
    </div>
  );
};

export default FormRow;
